// @ts-strict-ignore
import { forwardRef, Inject, Injectable, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  LMActionFormDialogComponent,
  LMActionFormDialogResult,
  LMActionFormDialogResultCode,
  LMActionFormDialogService
} from '@modal/index';
import { SohoMessageService } from 'ids-enterprise-ng';
import { LMTransactionState } from '@transaction/lm-transaction-state';
import { LMDialogButtonKey, LMUniqueIdService } from '@utils/index';

@Injectable()
export class LMListActionFormDialogService {
  constructor(
    @Inject(forwardRef(() => LMActionFormDialogService)) private lmActionFormDialogService, // LMActionFormDialogService,
    private sohoMessageService: SohoMessageService,
    private lmUniqueIdService: LMUniqueIdService
  ) {
  }

  private buttons: SohoModalButton[];

  modalOpen(): boolean {
    return this.lmActionFormDialogService.hasOpenDialog;
  }

  // TODO investigate refactoring this when implementing editable list. This is duplicated from lm-form.component.ts
  // and if the same could be moved to common area?
  displayNavigationConfirmation(): Promise<any> {
    const comp: LMActionFormDialogComponent = this.lmActionFormDialogService.getOpenDialog.componentDialog;
    const youMayNavigateSource = new BehaviorSubject<boolean>(false);
    const youMayNavigate: Observable<boolean> = youMayNavigateSource.asObservable();
    const dialogId = 'UnsavedChanges';

    if (comp?.formComponent?.isModified()) {
      this.buttons = [
        {
          id:    this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.LEAVE ]),
          text:  Soho.Locale.translate(LMDialogButtonKey.LEAVE),
          click: (e, modal) => {
            this.lmActionFormDialogService.getOpenDialog.close(<LMActionFormDialogResult>{ result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_CANCEL });
            youMayNavigateSource.next(true);
            youMayNavigateSource.complete();
            modal.close();
          }
        },
        {
          id:    this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.STAY ]),
          text:  Soho.Locale.translate(LMDialogButtonKey.STAY),
          click: (e, modal) => {
            youMayNavigateSource.next(false);
            youMayNavigateSource.complete();
            modal.close();
          }
        }
      ];

      // Show the confirmation message dialog.
      this.sohoMessageService
        .message() // todo akila, is this needed?
        .message(Soho.Locale.translate('NavigateAwayMessage'))
        .title(Soho.Locale.translate('UnsavedChangesMessage'))
        .buttons(this.buttons)
        .open();

    } else {
      // the form in the action form dialog component isn't dirty, so just return a boolean rather than
      // a promise attached to a confirmation
      this.lmActionFormDialogService.getOpenDialog.close();
      return;
    }

    return youMayNavigate.pipe(filter(el => el)).toPromise();
  }

  // deprecate this
  public getActionFormDialogDataView(formDataUrl: string): Observable<LMDataView> {
    // fronts for LMActionFormDialogService.getActionFormDialogDataView
    return this.lmActionFormDialogService.getActionFormDialogDataView(formDataUrl);
  }

  // deprecate this
  public runActionFormDialog(
    formUrlInfo: LMFormUrlInfo,
    formSpec: LMFormSpec,
    dataView: LMDataView,
    actionSpec: LMActionSpec,
    placeholder: ViewContainerRef,
    transactionState?: LMTransactionState
  ): Observable<LMActionFormDialogResult> {
    return this.lmActionFormDialogService.runActionFormDialog(formUrlInfo, formSpec, actionSpec, dataView, transactionState);
  }
}
